<template>
    <v-card class="pa-2">
        <v-card-text class="text-xs-center headline">
            Tem certeza que deseja deletar a rede <b>{{rede.nome}}</b>?
        </v-card-text>
        <v-card-actions class="justify-space-between mt-2">
          <v-btn @click="$emit('fechar')">Cancelar</v-btn>
          <v-btn color="error" @click="deletarRede">Confirmar</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
  props: ['rede'],
  methods: {
    deletarRede () {
      const r = this.rede || {}
      if (r.id_rede_empresa || r.rede_id) {
        const payload = { id_rede_empresa: r.id_rede_empresa || r.rede_id }
        this.$store.dispatch('deletarRedeEmpresa', payload).then(() => {
          this.$emit('success', 'Rede de empresas deletada com sucesso.')
          this.$emit('carregar')
          this.$emit('fechar')
        }).catch(() => {
          this.$emit('error', 'Não foi possível deletar rede de empresas.')
        })
        return
      }
      const id = r.id_rede || r.id
      if (id) {
        this.$store.dispatch('deletarRede', id).then(() => {
          this.$emit('success', 'Rede deletada com sucesso.')
          this.$emit('carregar')
          this.$emit('fechar')
        }).catch(() => {
          this.$emit('error', 'Não foi possível deletar rede.')
        })
        return
      }

      this.$emit('error', 'ID da rede não encontrado.')
    }
  }
}
</script>
